export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Latest sneaker & shoe finds curated daily",
    icon: "ri-footprint-line",
  },
  {
    name: "Hoodies / Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Cozy streetwear & premium knitwear",
    icon: "ri-t-shirt-line",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Graphic tees & essential basics",
    icon: "ri-shirt-line",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Outerwear & seasonal layers",
    icon: "ri-t-shirt-2-line",
  },
  {
    name: "Pants / Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Bottoms for every season & style",
    icon: "ri-pantone-line",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies & head accessories",
    icon: "ri-base-station-line",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Coordinated matching outfit sets",
    icon: "ri-group-line",
  },
  {
    name: "Underwear / Underpants",
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Essential innerwear & basics",
    icon: "ri-checkbox-blank-line",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys & athletic gear",
    icon: "ri-basketball-line",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, jewelry & finishing touches",
    icon: "ri-vip-diamond-line",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, totes & everyday carry",
    icon: "ri-briefcase-line",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Leather belts & statement pieces",
    icon: "ri-link",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrances & luxury scents",
    icon: "ri-drop-line",
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Everything else worth discovering",
    icon: "ri-more-line",
  },
];